
/**
 * Receive a number in String, with commas and dots, and return the float value
 * 
 * @param {String} formattedNumber 
 */
const GetUnformattedNumber = formattedNumber => parseFloat(formattedNumber.replace(/\./g, '').replace(',', '.'));

export default GetUnformattedNumber;